import { Folder } from 'lucide-react';

/**
 * Shared practice-session header used by both Manual and Automatic so the
 * responsive layout lives in ONE place. The mode/order badges sit on top,
 * side by side on a single row (never wrapping) and right-aligned; the
 * collection name sits underneath with the folder icon, in a smaller font that
 * wraps to two lines if it's long (rather than being cut off). Pass the
 * page-specific badges (mode/order) as children.
 */
export default function SessionHeader({ title, children }) {
    return (
        <header className="sticky top-0 z-40 bg-foreground/90 backdrop-blur-md border-b border-primary-foreground/10">
            <div className="max-w-3xl mx-auto px-4 md:px-6 py-2.5 md:py-3 flex flex-col gap-1.5">
                <div className="flex items-center gap-1.5 flex-nowrap justify-center md:justify-end whitespace-nowrap">
                    {children}
                </div>
                <div className="flex items-center justify-center md:justify-start gap-2 min-w-0" data-testid="session-collection-title">
                    <Folder className="h-5 w-5 text-primary-foreground flex-shrink-0" />
                    <span className="text-sm md:text-base font-bold text-primary-foreground leading-tight line-clamp-2">
                        {title}
                    </span>
                </div>
            </div>
        </header>
    );
}
